// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
  #courseCert.certInfo {
    width: 100%;
  }

  .courseCertNMLS {
    width: 100%;
  }
  .courseCertNMLS .name {
    font-size: 20px !important;
    top: 82% !important;
  }

  .courseCertNMLS .courseName {
    font-size: 30px !important;
    top: 54% !important;
    color: #228fc3;
  }

  .courseCertNMLS .completionDate {
    font-size: 20px !important;
    top: 82% !important;
    font-weight: normal;
  }

  .courseCertNMLS .nmlsID {
    font-size: 20px;
    top: 82%;
    color: #228fc3;
    left: 250px;
    text-align: center;
    width: 100%;
  }

  .courseCertNMLS .courseCode {
    font-size: 20px;
    top: 70%;
    color: #228fc3;
    left: 0px;
    text-align: center;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/print.css"],"names":[],"mappings":"AAAA;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;EACA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,cAAc;IACd,SAAS;IACT,kBAAkB;IAClB,WAAW;EACb;AACF","sourcesContent":["@media print {\n  #courseCert.certInfo {\n    width: 100%;\n  }\n\n  .courseCertNMLS {\n    width: 100%;\n  }\n  .courseCertNMLS .name {\n    font-size: 20px !important;\n    top: 82% !important;\n  }\n\n  .courseCertNMLS .courseName {\n    font-size: 30px !important;\n    top: 54% !important;\n    color: #228fc3;\n  }\n\n  .courseCertNMLS .completionDate {\n    font-size: 20px !important;\n    top: 82% !important;\n    font-weight: normal;\n  }\n\n  .courseCertNMLS .nmlsID {\n    font-size: 20px;\n    top: 82%;\n    color: #228fc3;\n    left: 250px;\n    text-align: center;\n    width: 100%;\n  }\n\n  .courseCertNMLS .courseCode {\n    font-size: 20px;\n    top: 70%;\n    color: #228fc3;\n    left: 0px;\n    text-align: center;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
